import Splide from '@splidejs/splide';

export const initCustomersSlider = () => {
  const buildersSliderEl = document.querySelector(
    '[data-pro-multifamily-overview-customers-content-builders]'
  );
  const buildersSlides = document.querySelectorAll(
    '[data-pro-multifamily-overview-customers-content-builders-slide]'
  );

  const buildersSlider = new Splide(buildersSliderEl, {
    type: 'slide',
    perPage: 3,
    perMove: 1,
    gap: 20,
    speed: 800,
    arrows: false,
    pagination: true,
    destroy: buildersSlides.length <= 3,
    omitEnd: true,
    classes: {
      pagination:
        'pro-multifamily-overview-customers__content-builders-pagination',
      page: 'pro-multifamily-overview-customers__content-builders-pagination-btn',
    },
    breakpoints: {
      1024: {
        destroy: false,
        perPage: 2,
      },
      680: {
        perPage: 1,
      },
    },
  });

  buildersSlider.mount();

  const quotesSliderEl = document.querySelector(
    '[data-pro-multifamily-overview-customers-content-quotes-slider]'
  );
  const quotesSlides = document.querySelectorAll(
    '[data-pro-multifamily-overview-customers-content-quotes-slide]'
  );

  if (quotesSliderEl) {
    const quotesSlider = new Splide(quotesSliderEl, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      speed: 800,
      drag: true,
      arrows: false,
      pagination: true,
      destroy: quotesSlides.length <= 1,
      classes: {
        pagination:
          'pro-multifamily-overview-customers__content-quotes-pagination',
        page: 'pro-multifamily-overview-customers__content-quotes-pagination-btn',
      },
    });

    quotesSlider.mount();
  }
};
